import type { Campaign } from 'features/campaigns'
import type {
	ChangeEventHandler,
	CSSProperties,
	FieldsetHTMLAttributes
} from 'react'

import clsx from 'clsx'
import { CustomTip } from 'components/atoms/tooltipCustom'
import {
	campaignConst,
	campaignsActions,
	campaignsSelectors
} from 'features/campaigns'
import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { typo } from 'shared/styles'

import css from './Statuses.module.css'

const labels = ['draft', 'paused', 'active', 'completed']
const VALUES: Campaign.State[] = ['Compose', 'Stopped', 'Running', 'Completed']

export function Statuses({
	className,
	...props
}: FieldsetHTMLAttributes<HTMLFieldSetElement>) {
	const state = useAppSelector(campaignsSelectors.filtersAsSet)

	const dispatch = useAppDispatch()

	const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
		event => {
			const filter = event.target.value as Campaign.State
			const action = campaignsActions.toggleFilter(filter)
			dispatch(action)
		},
		[dispatch]
	)

	return (
		<fieldset className={clsx(className, css.root)} {...props}>
			<legend className={clsx(typo.buttonSm, css.title)}>Status: </legend>
			<div className={css.filters}>
				{VALUES.map((filter, index) => (
					<CustomTip
						arrow
						enterDelay={500}
						enterNextDelay={500}
						key={filter}
						leaveDelay={0}
						title={labels[index]}
					>
						<input
							checked={state.has(filter)}
							className={clsx(css.filter, css[filter])}
							id={filter}
							name='filter'
							onChange={onChange}
							style={
								{
									'--active-color': campaignConst.statusToColor[filter]
								} as CSSProperties
							}
							type='checkbox'
							value={filter}
						/>
					</CustomTip>
				))}
			</div>
		</fieldset>
	)
}
